<div class="in-app-page">
  <ng-content></ng-content>
</div>
